import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['totalAmount', 'paymentEntry', 'paymentEntryExpiresAt', 'partialPaymentExpiresAt', 'partialPaymentsNumber', 'amountToPartial', 'partialPaymentAmountInput', 'partialPayments']

  connect() {
    this.updatePartialPayments()
  }

  updatePartialPayments() {
    this.data.set('changed-elements', JSON.stringify({}))
    this.amountToPartialTarget.value = this.amountToPartial().toFixed(2).replace(".", ",")
    const paymentEntryExpiresAt = moment(this.paymentEntryExpiresAtTarget.value, 'DD/MM/YYYY')

    let partialPayments = []

    const difference = (this.partialPaymentAmountWithTwoDecimals() * this.paymentsNumber()) - this.amountToPartial()
    let lastPaymentAmount = null
    if (difference != 0) {
      lastPaymentAmount = this.partialPaymentAmountWithTwoDecimals() - difference
    }
    for (let i = 0; i < this.paymentsNumber(); i++) {
      let amount = this.partialPaymentAmountWithTwoDecimals()

      if (lastPaymentAmount && i == this.paymentsNumber() - 1) {
        amount = Number(Math.round(lastPaymentAmount + 'e2') + 'e-2');
      }

      partialPayments[i] = { i: i, number: `${i + 1} de ${this.paymentsNumber()}`, expires_at: paymentEntryExpiresAt.add(1, 'M').format('DD/MM/YYYY'), amount: amount.toFixed(2).replace(".", ",") }
    }

    this.renderPartialPayments({ partialPayments: partialPayments })
  }

  updateExpiresAt(e) {
    const paymentNumber = $(e.target).data('payment-number')
    let targetExpiresAt = moment(e.target.value, 'DD/MM/YYYY')

    if (targetExpiresAt.isValid()) {
      for (let i = paymentNumber; i < this.paymentsNumber(); i++) {
        if (i <= paymentNumber) { continue }
        $(`#partial_payment_expires_at_${i}`).val(targetExpiresAt.add(1, 'M').format('DD/MM/YYYY'))
      }
    } else {
      $(e.target).val('Data Inválida')
    }

  }

  updateAmount(e) {
    const inserted_value = parseFloat(e.target.value.replace('.', '').replace(',', '.'))
    if (inserted_value > 0) {
      let changedElements = JSON.parse(this.data.get('changed-elements'))
      const paymentNumber = $(e.target).data('payment-number')

      changedElements[paymentNumber] = inserted_value
      this.data.set('changed-elements', JSON.stringify(changedElements))
      $(e.target).data('amount-changed', true)

      const unchangedElementsNumber = this.partialPaymentsNumberTarget.value - Object.keys(changedElements).length

      let changedElementsAmountsSum = 0
      changedElementsAmountsSum = Object.values(changedElements).reduce((a, b) => a + b)

      if (changedElementsAmountsSum > this.amountToPartial()) {
        e.target.setCustomValidity('Partials amount higher than amount to partial')
        e.target.classList.add('reveal-validation')
        return true
      } else {
        this.partialPaymentAmountInputTargets.forEach((e) => {
          if (parseFloat(e.value.replace('.', '').replace(',', '.')) > 0) {
            e.setCustomValidity('')
            e.classList.remove('reveal-validation')
          }
        })
      }

      const partialAmountForUnchangedElements = (Number(Math.round(((this.amountToPartial() - changedElementsAmountsSum) / unchangedElementsNumber) + 'e2') + 'e-2'))
      if (unchangedElementsNumber > 0) {
        const unchangedAmountInputs = $(this.partialPaymentAmountInputTargets).filter((i, element) => {
          return $(element).data('amount-changed') !== true
        })

        unchangedAmountInputs.each((i, element) => {
          // last one
          if (i + 1 === unchangedAmountInputs.length) {
            let amountRemainingForLast = this.amountToPartial() - (partialAmountForUnchangedElements * (unchangedElementsNumber - 1)) - changedElementsAmountsSum

            $(element).val(amountRemainingForLast.toFixed(2).replace(".", ","))
          } else {
            $(element).val(partialAmountForUnchangedElements.toFixed(2).replace(".", ","))
          }

        })

      } else {
        let lastPartialPaymentAmountInput = this.partialPaymentAmountInputTargets[this.partialPaymentAmountInputTargets.length - 1]

        delete changedElements[$(lastPartialPaymentAmountInput).data('payment-number')]
        changedElementsAmountsSum = Object.values(changedElements).reduce((a, b) => a + b)

        const lastPartialAmount = this.amountToPartial() - changedElementsAmountsSum
        $(lastPartialPaymentAmountInput).val((Number(Math.round(lastPartialAmount + 'e2') + 'e-2')).toFixed(2).replace(".", ","))
      }
    }
  }

  validateNotZero() {
    this.partialPaymentAmountInputTargets.forEach((e) => {
      if (parseFloat(e.value.replace('.', '').replace(',', '.')) == 0) {
        e.setCustomValidity("Partial amount can't be 0")
        e.classList.add('reveal-validation')
      }
    })
  }

  totalAmount() {
    return parseFloat(this.totalAmountTarget.textContent.replace('.', '').replace(',', '.'))
  }

  paymentEntry() {
    return parseFloat(this.paymentEntryTarget.value.replace('.', '').replace(',', '.'))
  }

  amountToPartial() {
    return this.totalAmount() - this.paymentEntry()
  }

  partialPaymentAmount() {
    return this.amountToPartial() / this.partialPaymentsNumberTarget.value
  }

  partialPaymentAmountWithTwoDecimals() {
    return Number(Math.round(this.partialPaymentAmount() + 'e2') + 'e-2')
  }

  paymentsNumber() {
    return this.partialPaymentsNumberTarget.value
  }

  renderPartialPayments(partialPayments) {
    $(this.partialPaymentsTarget).html(
      $(ejs.render(`
        <div class="block-partial-detail col-md-12">
        <% partialPayments.forEach(function(partialPayment){ %>
          <div class="content-partial-number clearfix">
            <div class="col-md-2">

              <input type="text" name="partial_payment_number[<%= partialPayment.i %>]" id="partial_payment_number_<%= partialPayment.i %>" value="<%= partialPayment.number %>" disabled="disabled" class="input-off-partial">
            </div>
            <div class="col-md-5">
              <label class="tw-py-1 md:tw-hidden">Vencimento: </label>
              <input type="text" name="partial_payment_expires_at[<%= partialPayment.i %>]" id="partial_payment_expires_at_<%= partialPayment.i %>" value="<%= partialPayment.expires_at %>" autocomplete="off" data-action="partial-payments#updateExpiresAt" data-controller="datepicker reveal-validation" data-target="partial-payments.partialPaymentExpiresAt" data-payment-number="<%= partialPayment.i %>" required="required" pattern="(0[1-9]|1[0-9]|2[0-9]|3[01])/(0[1-9]|1[012])/[0-9]{4}">
            </div>
            <div class="col-md-5">
              <label class="tw-py-1 md:tw-hidden">Valor: </label>
              <input type="text" name="partial_payment_amount[<%= partialPayment.i %>]" id="partial_payment_amount_<%= partialPayment.i %>" value="<%= partialPayment.amount %>" data-controller="mask", data-mask-format="#.##0,00", data-mask-reverse="true" data-action="keyup->partial-payments#updateAmount keyup->partial-payments#validateNotZero" data-target="quote-approve-validation.partialPaymentAmount partial-payments.partialPaymentAmountInput" data-payment-number="<%= partialPayment.i %>" required="required">
            </div>
          </div>
        <% }) %>
        </div>
        <span data-target="quote-approve-validation.amountSumError"></span>
      `, partialPayments))
    )
  }
}
